export default __webpack_public_path__ + "static/media/iss_logo_dark.d9c828d5.webp";